import React, { useState } from 'react';
import FsLightbox from 'fslightbox-react';
import { FaPlay } from 'react-icons/fa';
import ScrollAnimation from 'react-animate-on-scroll';
import SectionTitle from '../sectionTitle/SectionTitle';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import CalendlyPopupButton from '../calendly/CalendlyPopupButton';

const AboutUsChannel = () => {

    // Local state initialization
    const [toggler, setToggler] = useState(false);

    // Reading environment variable start
    const YOUTUBE_CHANNEL_URL = process.env.REACT_APP_YOUTUBE_CHANNEL_URL;
    // Reading environment variable end

    // Constant variables
    const videoLink = [YOUTUBE_CHANNEL_URL];

    return (
        <>
            <div className="edu-workshop-area eduvibe-home-three-video workshop-style-1 edu-section-gap bg-image bg-color-primary">
                <div className="container eduvibe-animated-shape">
                    <div className="row gy-lg-0 gy-5 row--60 align-items-center">
                        <div className="col-lg-6 order-2 order-lg-1">
                            <div className="workshop-inner">
                                <SectionTitle
                                    classes="text-white"
                                    slogan="Learn For Free"
                                    title="Join Our Academy For Free"
                                />

                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}
                                >
                                    <p className="description">
                                        Longswitch Academy helps you build a real career in Salesforce. We teach Salesforce Administration and Development through free step-by-step tutorials, industry-focused paid internships, free and premium eBooks, and free 30-minute guidance sessions. Whether you’re a fresher or switching careers, our learning approach is designed to give you practical skills, real project exposure, and career clarity, not just theory. Learn Salesforce the way it’s actually used in real projects.
                                    </p>
                                </ScrollAnimation>

                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    className="read-more-btn"
                                    animateOnce={true}
                                >
                                    {/* <a className="edu-btn btn-white" href={YOUTUBE_CHANNEL_URL} target="_blank" onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.ABOUT_US_PAGE_LEARN_FREE_MORE_UPCOMING_VIDEOS)} rel="noreferrer">More Upcoming Videos<i className="icon-arrow-right-line-right"></i></a> */}

                                    {/* TODO: 13012026 - Added the new route of Book Consultation instead of the Calendly Btn | Longswitch Front-End Team */}
                                    {/* TODO: 02022026 - Commented the newly Added route of Book Consultation | Longswitch Front-End Team */}
                                    <CalendlyPopupButton btnText="Book 1:1 Consultation" color='#F86F03' className='edu-btn subscribe btn-medium m-0' />
                                    {/* <a href={process.env.PUBLIC_URL + "/get-free-consultation"}
                                        target="_self"
                                        onClick={() =>
                                            triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.ABOUT_US_PAGE_CHOOSE_GUIDENCE_EXPLORE_COURSES)}
                                        className="edu-btn btn-consultation subscribe btn-medium m-0 fs-4" rel="noreferrer">
                                        Get Free Consultation <i className="icon-arrow-right-line-right"></i>
                                    </a> */}
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail video-popup-wrapper">
                                <img className="radius-small w-100" src={`${process.env.PUBLIC_URL}./images/videopopup/video-popup-bg-02.jpg`} alt="Video PopUp Thumb" />
                                <a href={YOUTUBE_CHANNEL_URL} target="_blank" onClick={() => triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.ABOUT_US_PAGE_LEARN_FOR_FREE_VIDEO_PLAY)} rel="noreferrer">
                                    <button className="video-play-btn with-animation position-to-top video-popup-activation color-secondary size-60">
                                        <span><FaPlay className="play-icon" /></span>
                                    </button>
                                </a> {/* Added a tag by Longswitch Team on 08/03/24 */}
                            </div>
                        </div>
                    </div>
                    {/* Modified by Longswitch Team added xxl for that nest hub max scroll issue  */}
                    <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                        <div className="shape-image shape-image-1">
                            <img src="/images/shapes/shape-09-01.png" alt="Shape Thumb" />
                        </div>
                        <div className="shape-image shape-image-2">
                            <img src="/images/shapes/shape-04-05.png" alt="Shape Thumb" />
                        </div>
                        <div className="shape-image shape-image-3">
                            <img src="/images/shapes/shape-13-02.png" alt="Shape Thumb" />
                        </div>
                    </div>
                </div>
            </div>
            <FsLightbox
                toggler={toggler}
                sources={videoLink}
                maxYoutubeVideoDimensions={{ width: 900, height: 550 }}
            />
        </>
    )
}

export default AboutUsChannel;